<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Trouvez des musiciens près de vous parmi les {{ all.users.totalCount + (all.users.totalCount > 1 ? ' inscrits' : ' inscrit') }}</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col cols="12">
          <GmapMap id="map" :center="center" :zoom="6" map-type-id="terrain">
            <GmapMarker
              :key="index"
              v-for="(marker, index) in markers"
              :position="marker.position"
              :clickable="true"
              @click="toggleInfoWindow(marker, index)"
            />
            <GmapInfoWindow
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWindowOpen"
              @closeclick="infoWindowOpen=false"
            >
              <div v-html="infoContent"></div>
            </GmapInfoWindow>
          </GmapMap>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "UserSearch",
  data: function() {
    return {
      markers: [],
      center: { lat: 47.996101, lng: 2.73268 },
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWindowOpen: false,
      currentMarkerIndex: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -25
        }
      }
    };
  },
  mounted: function() {
    this.getAll({ userId: this.user.id });
  },
  computed: {
    ...mapState("users", ["all"]),
    ...mapState("account", ["user"])
  },
  watch: {
    all: function(newVal) {
      if (newVal.loaded) {
        this.markers = newVal.users.data
          .filter(user => {
            if (
              user.address &&
              user.address.geometry &&
              user.address.geometry.location
            ) {
              return true;
            }
          })
          .map(user => {
            return {
              id: user.id,
              picture: user.picture,
              username: user.username,
              firstname: user.firstname,
              lastname: user.lastname,
              email: user.email,
              position: {
                lat: user.address.geometry.location.lat,
                lng: user.address.geometry.location.lng
              }
            };
          });
      }
    }
  },
  methods: {
    ...mapActions("users", ["getAll"]),
    toggleInfoWindow: function(marker, index) {
      this.center = marker.position;
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);

      if (this.currentMarkerIndex === index) {
        this.infoWindowOpen = !this.infoWindowOpen;
      } else {
        this.infoWindowOpen = true;
        this.currentMarkerIndex = index;
      }
    },
    getInfoWindowContent: function(marker) {
      return `
        <a href="/profile/${marker.id}" class="mapUserLink" title="${
        marker.username
      } (${marker.firstname} ${marker.lastname} ${marker.email})">
          <img src="${
            marker.picture
          }" alt="Photo de profil" width="30" height="30" class="rounded-circle" />
          ${marker.username} (${marker.firstname} ${marker.lastname} ${
        marker.email
      })
        </a>
      `;
    }
  }
};
</script>

<style>
#map {
  height: 100vh;
  width: 100%;
}
.mapUserLink {
  color: #2aab2a;
  text-decoration: none;
  font-weight: bold;
}
</style>
